import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  connect: () => void
}

const NotAuthenticated = ({ connect }: Props) => {
  return (
    <Box
      background="champagne200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
    >
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.datev_api.not_authenticated.title')}
      </Text.Header2>
      <Box>{i18n.t('payroll_integrations.incidences.datev_api.not_authenticated.message')}</Box>
      <Button onClick={connect} type="secondary">
        {i18n.t('payroll_integrations.incidences.datev_api.not_authenticated.submit')}
      </Button>
    </Box>
  )
}

export default NotAuthenticated
